module.exports = __webpack_public_path__ + "img/bg_roxo.365e0961.jpg";